import { useFrame, useLoader, useThree } from '@react-three/fiber';
import MoonImages from '../../assets/images/moon/index';
import { TextureLoader } from 'three/src/loaders/TextureLoader';
import { useRef, useState } from 'react';
import { Bounds } from '@react-three/drei';

const Moon = () => {
    const colorMap = useLoader(TextureLoader, MoonImages[0].img);
    const bumpMap = useLoader(TextureLoader, MoonImages[1].img);

    const ref = useRef();

    const interpolateFunc = (t: number) => 1 - Math.exp(-5 * t) + 0.007 * t; // Matches the default Bounds behavior

    useFrame((_, delta) => {
        ref.current.rotation.y += 0.02 * delta;
    });

    const { viewport } = useThree();

    return (
        // <Bounds fit clip observe margin={1} maxDuration={1} interpolateFunc={interpolateFunc}>
        <mesh
            rotation={[0, 0, 0]}
            ref={ref}
        >
            <sphereGeometry args={[1, 96, 96]} />
            <meshLambertMaterial
                map={colorMap}
                receiveShadow={false}
                roughness={0}
                bumpMap={bumpMap}
                bumpScale={0.8}
            />
        </mesh>
        // </Bounds>
    );
};

export default Moon;
